import { Helmet } from "react-helmet-async";
import { getPageSeoForPath } from "../../constants/seo";
import {
  absoluteUrl,
  DEFAULT_OG_IMAGE,
  SITE_NAME,
} from "../../constants/site";

type PageSeoProps = {
  pathname: string;
};

const PageSeo = ({ pathname }: PageSeoProps) => {
  const config = getPageSeoForPath(pathname);
  const canonical = absoluteUrl(config.path);
  const ogImage = config.ogImage ?? DEFAULT_OG_IMAGE;
  const robots = config.noindex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet prioritizeSeoTags>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={config.title} />
      <meta name="twitter:description" content={config.description} />
      <meta name="twitter:image" content={ogImage} />

      {config.jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(config.jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default PageSeo;
